<script setup>
import { defineProps, computed} from "vue";
import TabelaDeRecebimentosDeContasAReceber from "./TabelaDeRecebimentosDeContasAReceber/TabelaDeRecebimentosDeContasAReceber.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "contaAReceber",
]);


//==================================================================//
//======================= Mostra Recebimentos ======================//
//==================================================================//

let mostraRecebimentos = computed(()=>{

    if(props?.contaAReceber?.recebimentos?.length <= 0){
        return false;
    }

    if(props?.contaAReceber?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraRecebimentos"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDeRecebimentosDeContasAReceber
                    :dado="props?.dado"
                    :contaAReceber="props?.contaAReceber"
                ></TabelaDeRecebimentosDeContasAReceber>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
